import {Vue, Component, Prop} from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { BLOCK_MODULE_NAMESPACE, BLOCK_LOADERS } from '../../store/block'




const BlockStore= namespace(BLOCK_MODULE_NAMESPACE)

@Component({
  filters: {
    acronym(value:string){
      if(!value) return
      const [firstname,lastname] = value.trim().split(' ')
      if(!lastname) return firstname.slice(0,2)
      return `${firstname[0]}${lastname[0]}`
    }
  },
  components: {
    'block-infos-loader': async () => import('../../containers/block/loaders/block-infos-loader/BlockInfosLoader.vue')
  }
})
class UserProfileEnhancedWidget extends Vue {

  @Prop({ default: {} , type: [Object] })
  user: any
  @Prop({ default: () => false , type: [Boolean] })
  twoLine: boolean
  @Prop({default: false, type: [Boolean]})
  disable: boolean

  @BlockStore.Getter loaders: Map<string,boolean>

  constructor(){
    super()
  }

  get lblSetting() {
    return {
      ...require('@/locales/profile').default
    }
  }

  get avatarColor (): string {
    if (this.disable) return 'grey'
    return 'primary'
  }

  get iconColor (): string {
    if (this.disable) return 'grey'
    return 'black'
  }

  get roleValue() {
    return this.user.role_name
    /*
    switch (this.user.role) {
      case 'manager':
        return this.$t(this.lblSetting.manager)
      case 'manager-admin':
        return this.$t(this.lblSetting.managerAdmin)
      case 'tenant':
        return this.$t(this.lblSetting.tenant)
      case 'owner':
        return this.$t(this.lblSetting.owner)
      case 'independent_contractor':
        return this.$t(this.lblSetting.independentContractor)
      case 'concierge':
        return this.$t(this.lblSetting.caretaker)
      case 'Internal_contractor':
        return this.$t(this.lblSetting.internalContractor)
      case 'salesperson':
        return this.$t(this.lblSetting.salesperson)
      case 'customer':
        return this.$t(this.lblSetting.customer)
      case 'superadmin':
        return this.$t(this.lblSetting.administrator)
      default:
        return this.user.role
    }
     */
  }

  get fullname(): string{
    if (this.user.fullname) return this.user.fullname
    return `${this.user.firstname} ${this.user.lastname}`
  }

  get email() : string {
    return this.user.email
  }

  get address(): any {
    return this.user.address
  }

  get cellphone() {
    return this.user.cellphone
  }

  get landline() {
    return this.user.landline
  }

  get coInfosLoader(): boolean {
    return this.loaders.get(BLOCK_LOADERS.INFOS)
  }
}

export default UserProfileEnhancedWidget



// WEBPACK FOOTER //
// ./src/components/user-profile-enhanced-widget/index.ts